module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_Blue_Ownership-998d32e212bd054ab07f7b493fa4a720.png";